// extracted by mini-css-extract-plugin
export default {"row":"BottomNavigationBar_row__ZghkN","nextButton":"BottomNavigationBar_nextButton__X0i5N","errorTooltip":"BottomNavigationBar_errorTooltip__0IPCI"};